var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 143.083,
    height: 159.554,
    viewBox: "0 0 143.083 159.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d0b28a;}.b{fill:#b49770;}.c{fill:#e8d1b3;}.d{fill:#b17e5b;}.e{fill:#d81212;}.f{fill:#f0f0f0;}.g{fill:#4caf50;}.h{fill:#339137;}.i{fill:#fff;}.j{fill:#cfd1d3;}.k{fill:#dce1eb;}.l{fill:#818486;stroke:#cfd1d3;stroke-width:2px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-105 -71.446)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M286.569,128l13.669,46.474a5.561,5.561,0,0,1,.226,1.567v79.791H256V128Z",
    transform: "translate(-70.41 -28.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.779,351.916A2.779,2.779,0,0,1,336,349.137V290.779a2.779,2.779,0,1,1,5.558,0v58.358A2.779,2.779,0,0,1,338.779,351.916Z",
    transform: "translate(-122.621 -132.732)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M121.264,255.832H24V176.611a11.126,11.126,0,0,1,.332-2.7L37.895,128h97.264L121.6,173.915a11.128,11.128,0,0,0-.332,2.7Z",
    transform: "translate(81 -28.311)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.558,80C42.488,80,40,83.732,40,88.337s2.488,8.337,5.558,8.337H145.6V80Z",
    transform: "translate(70.558 3.015)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M304,469.895,317.895,456l13.895,13.895Z",
    transform: "translate(-101.736 -242.374)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M225.315,240l-1.309,28.912a1.8,1.8,0,0,0,.766,1.464,3.118,3.118,0,0,0,1.913.6h2.5a3.118,3.118,0,0,0,1.913-.6,1.8,1.8,0,0,0,.766-1.464L230.557,240Z",
    transform: "translate(-58.841 -54.604)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M205.242,59.385V55.454L200,54.143S201.311,24,210.485,24V59.385Z",
    transform: "translate(-38.769 126.011)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M81.315,176l-1.309,39.776a1.99,1.99,0,0,0,.766,1.578,2.967,2.967,0,0,0,1.913.645h2.5a2.967,2.967,0,0,0,1.913-.645,1.99,1.99,0,0,0,.766-1.578L86.557,176Z",
    transform: "translate(51.494 -1.574)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M75.708,24a1.34,1.34,0,0,0-1.224,1.352V38.416H71.863V25.355A1.341,1.341,0,0,0,70.64,24a1.311,1.311,0,0,0-1.4,1.308V38.416H66.621V25.355A1.34,1.34,0,0,0,65.4,24,1.311,1.311,0,0,0,64,25.31v16.6a5.242,5.242,0,0,0,1.048,3.145L67.932,48.9h5.242l2.883-3.844a5.242,5.242,0,0,0,1.048-3.145V25.31A1.311,1.311,0,0,0,75.708,24Z",
    transform: "translate(64.877 125.526)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "g",
    d: "M24.381,0C37.846,0,48.762,10.417,48.762,23.268S37.846,46.536,24.381,46.536,0,36.118,0,23.268,10.916,0,24.381,0Z",
    transform: "translate(136.942 71.446)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "h",
    d: "M243.707,128.917a25.8,25.8,0,0,0-2.707.144c12.341,1.316,21.673,11.274,21.673,23.124S253.341,173.992,241,175.309a25.8,25.8,0,0,0,2.707.143c13.465,0,24.381-10.417,24.381-23.268s-10.916-23.268-24.381-23.268Z",
    transform: "translate(-82.384 -57.47)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "i",
    d: "M11.327,15.137a2.123,2.123,0,0,0-2.759,0,1.608,1.608,0,0,0,0,2.459l5.829,5.2a2.072,2.072,0,0,0,1.38.5,2.046,2.046,0,0,0,1.4-.589l13.6-13.854a1.6,1.6,0,0,0-.23-2.386,2.117,2.117,0,0,0-2.685.1L15.777,19.033Z",
    transform: "translate(141.301 80.838)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "j",
    d: "M309.449,240.916V177.773a3.925,3.925,0,0,1,3.925-3.925h43.187a3.925,3.925,0,0,1,3.925,3.925v54.368l-12.7,12.7-34.409,0a3.925,3.925,0,0,1-3.925-3.925Z",
    transform: "translate(-112.403 -13.845)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "k",
    d: "M455.95,409.336v-12.7h12.7",
    transform: "translate(-220.571 -178.336)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "l",
    d: "M380.334,215.372h-31.16a1.978,1.978,0,1,1,0-3.925h31.16a1.978,1.978,0,1,1,0,3.925Zm-13.348,11.775H349.175a1.978,1.978,0,1,1,0-3.925h17.812a1.978,1.978,0,1,1,0,3.925Zm13.348,0H375.87a1.978,1.978,0,1,1,0-3.925h4.464a1.978,1.978,0,1,1,0,3.925ZM366.987,235H349.175a1.978,1.978,0,1,1,0-3.925h17.812a1.978,1.978,0,1,1,0,3.925Zm13.348,0H375.87a1.978,1.978,0,1,1,0-3.925h4.464a1.978,1.978,0,1,1,0,3.925Zm-13.348,7.85H349.175a1.978,1.978,0,1,1,0-3.925h17.812a1.978,1.978,0,1,1,0,3.925Zm13.348,0H375.87a1.978,1.978,0,1,1,0-3.925h4.464a1.978,1.978,0,1,1,0,3.925Zm-13.348,7.85H349.175a1.978,1.978,0,1,1,0-3.925h17.812a1.978,1.978,0,1,1,0,3.925Zm13.348,0H375.87a1.978,1.978,0,1,1,0-3.925h4.464a1.978,1.978,0,1,1,0,3.925Z",
    transform: "translate(-140.873 -35.534)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus1);
export default __webpack_public_path__ + "static/media/status-1.03c667046d01d02d006ae91692a54057.svg";
export { ForwardRef as ReactComponent };